// function updateHeroProductHeight(){console.log("Updating hero product height...");var e=document.querySelector(".hero-product"),t=e&&e.querySelector(".product__info-wrapper"),o=e&&e.querySelector(".product__gallery--wrapper");if(e&&t&&o){var r=t.offsetHeight,d=o.offsetHeight;console.log("Info Height:",r,"Gallery Height:",d);var a=Math.max(r,d);e.style.height=a+"px"}}$(document).ready((function(){var e=$(".product__gallery");e.owlCarousel({items:1,nav:!1,dots:!1,loop:!0,autoplay:!1,autoWidth:!1,center:!1,mouseDrag:!1,animateOut:"fadeOut",animateIn:"fadeIn"}),$(".product__thumbs .thumb").click((function(){e.trigger("to.owl.carousel",[$(this).data("index")-1,200,!0])}))})),"loading"===document.readyState?document.addEventListener("DOMContentLoaded",runHeroProductHeightUpdate):setTimeout(updateHeroProductHeight,1e3),document.addEventListener("resize",updateHeroProductHeight),document.querySelectorAll(".accordion details").forEach((function(e){e.addEventListener("toggle",updateHeroProductHeight)})),document.querySelectorAll(".accordion details").forEach((function(e){e.addEventListener("toggle",updateHeroProductHeight),e.addEventListener("transitionend",updateHeroProductHeight)}));
// Unminified version for editing & re-minifying
$(document).ready(function () {
  var productGallery = $(".product__gallery");

  productGallery.owlCarousel({
    items: 1,
    nav: false,
    dots: false,
    loop: true,
    autoplay: false,
    autoWidth: false,
    center: false,
    mouseDrag: false,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
  });

  $(".product__thumbs .thumb").click(function () {
    productGallery.trigger("to.owl.carousel", [
      $(this).data("index") - 1,
      200,
      true,
    ]);
  });
});

// Dynamically set .hero-product height to fit content including absolute positioned accordions
function updateHeroProductHeight() {
  console.log("Updating hero product height...");
  var heroProduct = document.querySelector(".hero-product");
  var infoWrapper =
    heroProduct && heroProduct.querySelector(".product__info-wrapper");
  var galleryWrapper =
    heroProduct && heroProduct.querySelector(".product__gallery--wrapper");
  if (!heroProduct || !infoWrapper || !galleryWrapper) return;

  // Get heights of both wrappers
  var infoHeight = infoWrapper.offsetHeight;
  var galleryHeight = galleryWrapper.offsetHeight;

  console.log("Info Height:", infoHeight, "Gallery Height:", galleryHeight);

  // Set hero-product height to the bigger height
  var newHeight = Math.max(infoHeight, galleryHeight);
  heroProduct.style.height = newHeight + "px";
}

// // Update on load, resize, and accordion toggle
// if (document.readyState === "loading") {
//   document.addEventListener("DOMContentLoaded", runHeroProductHeightUpdate);
// } else {
//   setTimeout(updateHeroProductHeight, 1000);
// }

// document.addEventListener("resize", updateHeroProductHeight);
// document.querySelectorAll(".accordion details").forEach(function (details) {
//   details.addEventListener("toggle", updateHeroProductHeight);
// });

// // Also update after accordion transitions
// document.querySelectorAll(".accordion details").forEach(function (details) {
//   details.addEventListener("toggle", updateHeroProductHeight);
//   details.addEventListener("transitionend", updateHeroProductHeight);
// });

// Initial update after everything is loaded
window.addEventListener("load", function() {
  updateHeroProductHeight();

  // Retry after a short delay in case of late-loading content
  setTimeout(updateHeroProductHeight, 500);
  setTimeout(updateHeroProductHeight, 1200);
});

// Update on resize
window.addEventListener("resize", updateHeroProductHeight);

// Update on accordion toggle and transition
document.querySelectorAll(".accordion details").forEach(function(details) {
  details.addEventListener("toggle", updateHeroProductHeight);
  details.addEventListener("transitionend", updateHeroProductHeight);
});
